import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmComponent } from './confirm.component';
import { ConfirmService } from './confirm.service';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * Module for confirm dialog component
 */
@NgModule({
  imports: [
    CommonModule,
    NgbModalModule
  ],
  declarations: [ConfirmComponent],
  providers: [ConfirmService],
  exports: [ConfirmComponent]
})
export class ConfirmModule { }
